module.exports = __webpack_public_path__ + "img/galleria-original-480.dbc301e3.png";